// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3g1kt","info":"Note_info__3-0Kd","note":"Note_note__3TL7U","actions":"Note_actions__3Ze48"};